export class Hasher {
    hashText(hash, message) {
        hash.init();
        hash.update(new TextEncoder().encode(message));
        return hash.digest();
    }
    // x: () => void
    async hashFile(hash, file, chunkSize = 0, progressCallback = null) {
        if (chunkSize === 0) {
            chunkSize = 64 * Hasher.SIZE_1MB;
        }
        if (progressCallback === null) {
            progressCallback = ( /*current: number, total: number*/) => {
            };
        }
        let offset = 0;
        hash.init();
        while (offset < file.size) {
            progressCallback(offset, file.size);
            const chunk = await this.readFileAt(file, offset, chunkSize);
            hash.update(chunk);
            offset += chunkSize;
        }
        progressCallback(offset, file.size);
        return hash.digest();
    }
    async readFileAt(file, offset, length) {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            let blob = file.slice(offset, offset + length);
            reader.onload = (evt) => {
                if (evt.target.error) {
                    reject(evt);
                }
                else {
                    resolve(new Uint8Array(reader.result));
                }
            };
            reader.onerror = reject;
            reader.readAsArrayBuffer(blob);
        });
    }
}
Hasher.SIZE_1MB = 1048576;
